/* Terms + return policy consent gate for the cart drawer and cart page.
   - Checkout button / express-payment buttons stay visible but greyed out until the box is ticked.
   - Ticking saves the time as a cart attribute, which appears on the order under "Additional details".
   Client-side only: it cannot stop someone who types /checkout into the address bar. */
(function () {
  if (window.__ibisTermsConsent) return;
  window.__ibisTermsConsent = true;

  var KEY = 'ibis_terms_agreed';
  var ATTR = 'Terms and return policy agreed';
  var CHECKOUT = 'button[name="checkout"], input[name="checkout"]';
  var EXPRESS = '.additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="payment-button"]';

  var agreed = false;
  try { agreed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

  function saveAttribute(on) {
    var attrs = {};
    attrs[ATTR] = on ? new Date().toISOString() : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function visibleBox(from) {
    var boxes = document.querySelectorAll('[data-terms-consent]');
    var scoped = from && from.closest('form') && from.closest('form').parentElement.querySelector('[data-terms-consent]');
    if (scoped) return scoped;
    for (var i = 0; i < boxes.length; i++) if (boxes[i].offsetParent !== null) return boxes[i];
    return boxes[0] || null;
  }

  function showError(from) {
    var box = visibleBox(from);
    if (!box) return;
    box.classList.add('has-error');
    var input = box.querySelector('.terms-consent__input');
    if (input) input.focus();
  }

  var queued = false;
  function sync() {
    queued = false;
    document.querySelectorAll('.terms-consent__input').forEach(function (i) { if (i.checked !== agreed) i.checked = agreed; });
    document.querySelectorAll('[data-terms-consent]').forEach(function (b) { if (agreed) b.classList.remove('has-error'); });
    document.querySelectorAll(CHECKOUT).forEach(function (b) {
      b.classList.toggle('is-terms-locked', !agreed);
      b.setAttribute('aria-disabled', agreed ? 'false' : 'true');
    });
    document.querySelectorAll(EXPRESS).forEach(function (e) { e.classList.toggle('is-terms-locked', !agreed); });
  }
  function queueSync() { if (!queued) { queued = true; requestAnimationFrame(sync); } }

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('terms-consent__input')) return;
    agreed = e.target.checked;
    try { sessionStorage.setItem(KEY, agreed ? '1' : '0'); } catch (err) {}
    saveAttribute(agreed);
    sync();
  });

  // Greyed-out Checkout button: block the click and point at the checkbox.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(CHECKOUT);
    if (btn && !agreed) { e.preventDefault(); e.stopPropagation(); showError(btn); }
  }, true);

  // Submit (covers Enter key too). When agreed, save the timestamp first, then continue to checkout.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector || !form.querySelector(CHECKOUT)) return;
    var submitter = e.submitter;
    var isCheckout = !submitter || (submitter.matches && submitter.matches(CHECKOUT));
    if (!isCheckout) return;
    if (!agreed) { e.preventDefault(); e.stopPropagation(); showError(form); return; }
    if (form.__termsSaved) return;
    e.preventDefault();
    saveAttribute(true).then(function () {
      form.__termsSaved = true;
      if (form.requestSubmit && submitter) form.requestSubmit(submitter); else form.submit();
      form.__termsSaved = false;
    });
  }, true);


  /* ---- Policy pop-up: the Terms / Return Policy links open the policy text in a dialog ---- */
  var cache = {};
  var dlg = null;
  function injectModalStyles() {
    if (document.getElementById('terms-modal-styles')) return;
    var st = document.createElement('style');
    st.id = 'terms-modal-styles';
    st.textContent =
      '.terms-modal{border:0;border-radius:12px;padding:0;width:min(720px,calc(100vw - 2rem));max-height:min(80vh,720px);color:rgb(var(--text-color,0 0 0));background:rgb(var(--background,255 255 255));box-shadow:0 20px 60px rgba(0,0,0,.35)}' +
      '.terms-modal::backdrop{background:rgba(0,0,0,.55)}' +
      '.terms-modal__inner{display:flex;flex-direction:column;max-height:inherit}' +
      '.terms-modal__head{display:flex;justify-content:space-between;align-items:center;gap:1rem;padding:1rem 1.25rem;border-bottom:1px solid rgba(0,0,0,.12)}' +
      '.terms-modal__title{margin:0;font-size:1.25rem}' +
      '.terms-modal__close{flex:none;border:0;background:none;font-size:1.75rem;line-height:1;cursor:pointer;color:inherit;padding:0 .25rem}' +
      '.terms-modal__body{padding:1rem 1.25rem 1.5rem;overflow-y:auto;overscroll-behavior:contain;font-size:.9375rem;line-height:1.55}' +
      '.terms-modal__body h1,.terms-modal__body h2,.terms-modal__body h3{font-size:1.05rem;margin:1.25rem 0 .5rem}' +
      '.terms-modal__body p,.terms-modal__body ul,.terms-modal__body ol{margin:0 0 .85rem}' +
      '.terms-modal__body a{text-decoration:underline;text-underline-offset:2px}' +
      '.terms-modal__body ul,.terms-modal__body ol{padding-inline-start:1.25rem}';
    document.head.appendChild(st);
  }
  // Drawers (cart drawer, quick-add popup) trap focus and close on outside clicks/Esc, so inside one the pop-up is
  // created INSIDE that drawer element (still shown on top via showModal); elsewhere it goes on <body>.
  // Links inside the policy text (e.g. "click here" to start a return) open in a new tab so the cart stays put.
  function openLinksInNewTab(el) {
    el.querySelectorAll('a[href]').forEach(function (l) {
      var href = (l.getAttribute('href') || '').trim();
      if (href.charAt(0) === '#' || /^(mailto|tel|sms):/i.test(href)) { l.removeAttribute('target'); return; } // in-page anchors and email/phone links: leave to the browser
      l.target = '_blank';
      l.rel = 'noopener';
    });
  }
  function getDialog(host) {
    if (dlg && dlg.isConnected && dlg.parentElement === host) return dlg;
    if (dlg && dlg.isConnected) dlg.remove();
    injectModalStyles();
    dlg = document.createElement('dialog');
    dlg.className = 'terms-modal';
    dlg.innerHTML = '<div class="terms-modal__inner"><div class="terms-modal__head"><h2 class="terms-modal__title"></h2><button type="button" class="terms-modal__close" aria-label="Close">&times;</button></div><div class="terms-modal__body"></div></div>';
    dlg.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === dlg || (e.target.closest && e.target.closest('.terms-modal__close'))) dlg.close();
    });
    host.appendChild(dlg);
    return dlg;
  }
  var POLICIES = ['/policies/terms-of-service', '/policies/refund-policy', '/policies/shipping-policy'];
  // Links that open in the pop-up: the checkbox links, plus any policy link inside the cart drawer / cart summary (e.g. "shipping" in the taxes note).
  var POLICY_LINK = 'a[data-terms-policy], cart-drawer a[href*="/policies/"], safe-sticky a[href*="/policies/"], .terms-modal__body a[href*="/policies/"]';
  var ready = {};
  function loadPolicy(url) {
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('bad status');
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var body = doc.querySelector('.shopify-policy__body');
      if (!body) throw new Error('no policy body');
      var title = doc.querySelector('.shopify-policy__title');
      ready[url] = { title: (title ? title.textContent : '').trim(), html: body.innerHTML };
      return ready[url];
    }).catch(function (err) { delete cache[url]; throw err; });
    return cache[url];
  }
  // Fetch both policies in the background so the pop-up opens with the text already there.
  function prefetch() { POLICIES.forEach(function (u) { loadPolicy(u).catch(function () {}); }); }
  setTimeout(prefetch, 800);
  ['pointerover', 'touchstart', 'focusin'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (e.target.closest && e.target.closest('[data-terms-consent], ' + POLICY_LINK)) prefetch();
    }, { capture: true, passive: true });
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest(POLICY_LINK);
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    if (typeof HTMLDialogElement === 'undefined') return; // old browser: normal link
    e.preventDefault();
    e.stopPropagation();
    var d = getDialog(a.closest('cart-drawer, quick-buy-drawer, [aria-modal="true"]') || document.body);
    var url = new URL(a.href, location.href).pathname;
    var titleEl = d.querySelector('.terms-modal__title'), bodyEl = d.querySelector('.terms-modal__body');
    if (ready[url]) {
      titleEl.textContent = ready[url].title || (a.textContent || '').trim();
      bodyEl.innerHTML = ready[url].html;
      openLinksInNewTab(bodyEl);
      bodyEl.scrollTop = 0;
    } else {
      titleEl.textContent = (a.textContent || '').trim();
      bodyEl.textContent = 'Loading…';
    }
    if (!d.open) d.showModal();
    loadPolicy(url).then(function (p) {
      if (p.title) d.querySelector('.terms-modal__title').textContent = p.title;
      d.querySelector('.terms-modal__body').innerHTML = p.html;
      openLinksInNewTab(d.querySelector('.terms-modal__body'));
      d.querySelector('.terms-modal__body').scrollTop = 0;
    }).catch(function () {
      d.close();
      window.open(a.href, '_blank', 'noopener');
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dlg && dlg.isConnected && dlg.open) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dlg.close();
    }
  }, true);

  new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
